import { formatNumber } from "@/lib/i18n";
import { useApi } from "./use-api";

export interface DashboardMetric {
  label: string;
  value: string;
  trend: "up" | "down" | "flat";
  trendValue: string;
}

export interface DashboardSummary {
  contacts: number;
  pipelineValue: number;
  openDeals: number;
  revenueThisMonth: number;
  responseTime?: string;
}

/** Format currency — show exact value below €1K, abbreviated above */
export function formatCurrency(amount: number): string {
  if (amount >= 1000) return `€${(amount / 1000).toFixed(1)}K`;
  return `€${formatNumber(Math.round(amount))}`;
}

export function formatMetrics(summary: DashboardSummary): DashboardMetric[] {
  return [
    { label: "Contacts", value: formatNumber(summary.contacts), trend: "flat", trendValue: "Live total" },
    { label: "Pipeline", value: formatCurrency(summary.pipelineValue), trend: "flat", trendValue: "Open deal value" },
    { label: "Open Deals", value: formatNumber(summary.openDeals), trend: "flat", trendValue: "Currently active" },
    { label: "Revenue MTD", value: formatCurrency(summary.revenueThisMonth), trend: "flat", trendValue: "Won this month" },
    // Operational metadata — consider separating from business KPIs in future
    { label: "Query Time", value: summary.responseTime ?? "—", trend: "flat", trendValue: "Dashboard API latency" },
  ];
}

export function useDashboardMetrics() {
  const { data: summary, isLoading, error } = useApi<DashboardSummary>("/v1/dashboard/summary");
  const metrics = summary ? formatMetrics(summary) : null;
  return { data: metrics, summary, isLoading, error };
}
